import { push } from 'connected-react-router';
import {
    REDIRECT_TO_HOME, REDIRECT_TO_ROUTE, REDIRECT_TO_SIGN_IN,
} from './auth-base-state';
import { ROUTES } from './auth.constants';
import { createMiddleware } from '../../shared/redux';

export const authMiddleware = createMiddleware({
    [REDIRECT_TO_HOME]: () => push('/'),
    [REDIRECT_TO_SIGN_IN]: () => push(ROUTES.SIGN_IN),
    [REDIRECT_TO_ROUTE]: (state, action) => push(action.payload.route),
});
